module.exports = __webpack_public_path__ + "static/media/thumbs-brown.5e3cca35.png";